
export const runValidateFields = (field, value) => {

    switch (field) {
        case "email":
            let validationResponse = validarEspaciosEnBlanco(field, value);
            return validationResponse;

        default:
            break;
    }


}

export const validarSoloNumeros = (value = "") => {
    let isValid = false;
    if (value.length <= 0) {
        return isValid;
    }
    let ExpRegSoloNumeros = "^[0-9]+$";
    let regexField = value.match(ExpRegSoloNumeros)
    if (regexField !== null) {
        isValid = true;
    }

    return isValid;
}


export const validarEspaciosEnBlanco = (field, value = "") => {
    let message;
    let isError = false

    if (value.indexOf(" ") !== -1) {
        message = `El ${field} no puede contener espacios en blanco`;
        isError = true;
        return [isError, message];
    }
    message = "";
    return [isError, message]
}

export const removeAccents = (value = "") => {
    if (value.length <= 0) {
        return value
    }
    let value2 = value.normalize("NFD").replace(/\p{Diacritic}/gu, "");
    return value2
}

export const removeSpecialCharsAndEmojis = (str) => {
    return str.replace(/[^a-zA-Z0-9\s]/g, '');
}

export function normalizeEmail(email) {
  if (!email) return '';

  email = email.trim();

  // Remover múltiples @
  const atCount = (email.match(/@/g) || []).length;
  if (atCount > 1) {
    const lastAtIndex = email.lastIndexOf('@');
    email = email.substring(0, lastAtIndex).replace(/@/g, '') + '@' + email.substring(lastAtIndex + 1);
  }

  const [username, ...domainParts] = email.split('@');
  if (!username || domainParts.length === 0) return email;

  const domain = domainParts.join('');

  // Normalizar usuario: remover caracteres inválidos y duplicados especiales
  let cleanUsername = username
    .replace(/[^a-zA-Z0-9._%-]/g, '') // Solo caracteres válidos
    .replace(/\.+/g, '.') // Remover puntos duplicados
    .replace(/_{2,}/g, '_') // Remover guiones bajos duplicados
    .replace(/\-+/g, '-') // Remover guiones duplicados
    .replace(/^[-_.]+/, '') // Remover guiones, puntos, guiones bajos al inicio
    .replace(/[-_.]+$/, ''); // Remover guiones, puntos, guiones bajos al final

  // Normalizar dominio: remover caracteres inválidos y duplicados
  let cleanDomain = domain
    .replace(/[^a-zA-Z0-9.-]/g, '') // Solo caracteres válidos
    .replace(/\.+/g, '.') // Remover puntos duplicados
    .replace(/\-+/g, '-') // Remover guiones duplicados
    .replace(/^[\.-]+/, '') // Remover punto/guión al inicio
    .replace(/-+$/, '') // Remover guiones al final (permitir puntos)
    .replace(/\.-/g, '.') // Remover guión después de punto
    .replace(/-\./g, '.'); // Remover punto después de guión

  return cleanUsername && cleanDomain ? `${cleanUsername}@${cleanDomain}` : email;
}

export function isValidEmail(email) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
  return regex.test(email);
}

export function isValidEmailUnicode(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/u;
  return regex.test(email);
}

// 1. Valida la longitud máxima para evitar desbordamiento (Buffer Overflow)
export const validarLongitudMaxima = (valor, max) => {
  if (!valor) return true;
  return valor.toString().length <= max;
};

// 2. Bloquea inyección de caracteres especiales y etiquetas HTML (XSS)
export const contieneCaracteresPeligrosos = (valor) => {
  if (!valor) return false;
  // Regex basado en la lista del auditor: %!”#$&/()?¡<>\;:*[]{}—‘~
  // Incluye explícitamente < y > para mitigar inyección de etiquetas HTML
  const regexPeligroso = /[%!”#$&/()?¡<>;:*[\]{}—‘~]/;
  return regexPeligroso.test(valor.toString());
};
